@if (!isLoaded()) {
  <app-loading-placeholder />
} @else {
  <ng-progress />
  <div
    class="App-content"
    [ngClass]="{ 'is-reloading': pageReloading }">
    <router-outlet />
  </div>
}
